<template>
  <div id="add-edit-branch-container" class="vx-col w-full">
    <vx-card class="digitelex-popup-content">
      <form>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'required|alpha_num|min:2'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Branch Name"
              label-placeholder="Branch Name"
              name="branchName"
              v-model="frm.branchName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('branchName')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("branchName") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('branchName')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'required|decimal:10'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Mobile No"
              label-placeholder="Mobile No"
              name="mobileNo"
              v-model="frm.mobileNo"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('mobileNo')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("mobileNo") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('mobileNo')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'email'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Email"
              label-placeholder="Email"
              name="email"
              v-model="frm.email"
              type="text"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('email')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("email") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('email')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-select
              autocomplete
              class="Location"
              label="Location"
              v-validate="'required'"
              data-vv-validate-on="input|keyup|blur|click"
              placeholder="Locations"
              label-placeholder="vs-Multiple"
              name="locationId"
              v-model="frm.locationId"
              icon="arrow_downward"
              width="100%"
            >
              <vs-select-item
                :key="index"
                :value="item.locationId"
                :text="item.locationName"
                v-for="(item, index) in locations"
              />
            </vs-select>
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('locationId')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("locationId") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('locationId')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-select
              autocomplete
              class="Branch Type"
              label="Branch Type"
              v-validate="'required'"
              data-vv-validate-on="input|keyup|blur|click"
              placeholder="Branch Type"
              label-placeholder="vs-Multiple"
              v-model="frm.branchTypeId"
              icon="arrow_downward"
              width="100%"
              name="branchTypeId"
            >
              <vs-select-item
                :key="index"
                :value="item.branchTypeId"
                :text="item.branchTypeText"
                v-for="(item, index) in branchTypeEnum"
              />
            </vs-select>
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('branchTypeId')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("branchTypeId") }}
              </span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('branchTypeId')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'alpha_num|min:2'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Manager Name"
              label-placeholder="Manager Name"
              name="manager"
              v-model="frm.manager"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('manager')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("manager") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('manager')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'decimal:10'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Manager  Mobile No "
              label-placeholder="Manager Mobile No "
              name="managerMobileNo"
              v-model="frm.managerMobileNo"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('managerMobileNo')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("managerMobileNo") }}
              </span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('managerMobileNo')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="flex flex-wrap justify-end">
          <vs-button
            :disabled="!validateForm"
            @click="saveBranch"
            class="ml-auto"
            >Save Changes</vs-button
          >
          <vs-button
            class="ml-4"
            @click="
              frm = {
                isActive: true,
                branchName: '',
                locationId: '',
                email: '',
                mobileNo: null,
                manager: '',
                managerMobileNo: null,
                branchTypeId: '',
                branchId: 0,
              }
            "
            color="danger"
            >Reset</vs-button
          >
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    clientName: {
      required: "Please enter your first name",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

Validator.localize("en", dict);

export default {
  props: {
    frmData: {},
  },
  methods: {
    getLocations() {
      this.$http.get("common/locations").then((response) => {
        this.locations = response.data.data;
        this.getBranchTypes();
      });
    },
    getBranchTypes() {
      this.$http.get("common/branchTypeEnum").then((response) => {
        this.branchTypeEnum = response.data.data;
        // this.$vs.loading.close("#add-edit-branch-container > .con-vs-loading");
      });
    },
    saveBranch() {
      if (this.frm.branchId) {
        //Update
        // alert("Updated");
        this.$http
          .put("common/branch", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
            let message = error.response.data.message;
            this.$vs.dialog({
              color: "danger",
              title: `Error in Editing location`,
              text: `${message}`,
              accept: console.log(error.response.data.message),
            });
          });
      } else {
        this.frm.branchId = 0;
        this.frm.isActive = true;
        this.$http
          .post("common/branch", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            let message = error.response.data.message;
            this.$vs.dialog({
              color: "danger",
              title: `Error in Editing location`,
              text: `${message}`,
              accept: console.log(error.response.data.message),
            });
            console.log(error);
          });
      }
    },
  },
  data() {
    return {
      locations: [],
      branchTypeEnum: [],
      frm: {
        isActive: true,
        branchName: "",
        locationId: -1,
        email: "",
        mobileNo: null,
        manager: "",
        managerMobileNo: null,
        branchTypeId: -1,
        branchId: 0,
      },
    };
  },
  watch: {
    frmData: {
      handler(after) {
        console.log(this.errors);
        this.frm = after;
      },
      immediate: true,
    },
  },

  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.frm.branchName != "" &&
        this.frm.branchName != null &&
        this.frm.locationId != 0 &&
        this.frm.locationId != -1 &&
        this.frm.locationId != null &&
        this.frm.branchTypeId != 0 &&
        this.frm.branchTypeId != -1 &&
        this.frm.branchTypeId != null
      );
    },
  },
  beforeMount() {
    // console.log(this.frmData);
    // this.$vs.loading({
    //   container: "#add-edit-branch-container",
    //   scale: 0.6,
    // });
    this.getLocations();
  },
};
</script>
